// extracted by mini-css-extract-plugin
module.exports = {"content":"workingoperation_content__2AqnA","center":"workingoperation_center__3zOBX"};